import {css, Stack, styled} from '@mui/material';

const FooterDrawer = styled(Stack)`
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 8px;

	padding: 16px;
	${({theme}) => css`
		border-top: 1px solid ${theme.colors.gray['40Percent']};
	`}
`;

export {FooterDrawer};
